import { render } from "./LightboxRecency.vue?vue&type=template&id=0924fbfb&scoped=true"
import script from "./LightboxRecency.vue?vue&type=script&lang=js"
export * from "./LightboxRecency.vue?vue&type=script&lang=js"

import "./LightboxRecency.vue?vue&type=style&index=0&id=0924fbfb&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0924fbfb"]])

export default __exports__